import type { UploadFileType } from "@/components/utils/uploadFile";
import type { LomdaV3AssetType } from "@/lib/utils/lomdaV3/types";
import { useLomdaV3Editor } from "../store/useLomdaV3Editor";
import { assetTypeOfMime } from "../lib/mediaAssets";

export const lomdaBatchKey = (lomdaId: string, key = "") =>
    `lomda-v3:${lomdaId}:${key}`;

export function useLomdaUploadTarget(folder?: string) {
    const userId = useLomdaV3Editor((s) => s.userId);
    const lomdaId = useLomdaV3Editor((s) => s.lomdaId);
    const recordAsset = useLomdaV3Editor((s) => s.recordAsset);
    const base = `users/${userId}/lomda-v3/${lomdaId}`;
    const sameLomda = () => useLomdaV3Editor.getState().lomdaId === lomdaId;

    return {
        lomdaId,
        fileUploadPath: folder ? `${base}/${folder}` : base,
        sameLomda,
        record: (file: UploadFileType, fallback?: LomdaV3AssetType) =>
            sameLomda() &&
            recordAsset({
                url: file.fileUrl,
                type: assetTypeOfMime(file.fileType, fallback),
                name: file.fileName,
                uploadedAt: new Date().toISOString(),
                size: file.fileSize,
            }),
    };
}
